export const oneClickDistribution = () => {
  return [100, 0];
};
